import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import type { RegistrationCampaign } from '@hotjar/webapp/domains/campaigns/model';
import { DEFAULT_REGISTRATION_PLAN } from '@hotjar/webapp/domains/campaigns/api';
import * as googleAnalytics from '@hotjar/webapp/tracking/tools/google-analytics';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import * as hotjarTracking from '../tools/hotjar';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export interface SignupTrackingData {
  signupMethod?: string;
  signupStep: string;
  signupStepNumber: number;
  campaign?: RegistrationCampaign;
  locale?: string;
}

const signupStepProgress = (signupData: SignupTrackingData, action?: 'Submitted' | 'Completed') => {
  const { signupStep, signupStepNumber, campaign, locale } = signupData;
  const signupMethod = signupData.signupMethod || '';
  const eventName = action
    ? `Signup Step ${signupStepNumber} ${action}`
    : `Signup Step ${signupStepNumber}`;
  const segmentEventName = action ? `Signup Step ${action}` : 'Signup Step';

  hotjarTracking.tagRecording(eventName);
  googleAnalytics.trackAccountEvent(eventName, signupMethod);
  Segment.track(
    segmentEventName,
    keysToSnakeCase({
      ...(campaign
        ? // If this campaign isn't valid, we send the campaign hash from queryString
          // so we can monitor which are the ones still being used.
          { trialCampaignHash: campaign.hash, trialCampaignValid: !!campaign.valid }
        : {}),
      ...(campaign?.details
        ? {
            trialCampaignId: campaign.details.id,
            trialCampaignName: campaign.details.name,
            trialCampaignPlan: campaign.details.plan,
            trialCampaignPeriod: campaign.details.numFreeDays,
            trialCampaignDailyPageviews: campaign.details.numFreeDays,
          }
        : {}),
      signupSitePlan: campaign?.plan || DEFAULT_REGISTRATION_PLAN,
      signupMethod,
      signupStep,
      signupStepNumber,
      ...(typeof locale === 'string' ? { locale } : {}),
    }),
  );
};

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * Track that the user has advanced to a specific step in the signup process.
 */
export const signupStepLoaded = (signupData: SignupTrackingData): void => {
  signupStepProgress(signupData);
};

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * Track when a signup steo is submitted.
 */
export const signupStepSubmitted = (signupData: SignupTrackingData): void => {
  signupStepProgress(signupData, 'Submitted');
};

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * Track when a signup steo is completed.
 */
export const signupStepCompleted = (signupData: SignupTrackingData): void => {
  signupStepProgress(signupData, 'Completed');
};
